import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Cargando...</div>; // Mientras se verifica la sesión

  if (!user) {
    // Si no está autenticado, redirigir al login
    return <Navigate to="/login" />;
  }

  // Verificar si el rol del usuario está permitido
  // if (!allowedRoles.includes(user.rol_id)) {
  //   return <Navigate to="/login" />;
  // }

  // Validación adicional para profesores (rol_id === 2)
  if (
    user.rol_id === 2 &&
    user.director_salon === null &&
    (window.location.pathname === "/estudiantes" &&
      window.location.pathname === "/notas")
  ) {
    // Si es profesor sin salón asignado y está intentando acceder a rutas restringidas
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
